<template>
  <div class="Q col s12 m8 offset-m2 l6 offset-l3">
    <div class="card padding">
      <div class="row valign-wrapper">
        <div class="col s12">
          <p class="right tag">Q</p>
            <h6><i>Links:</i></h6> 
            <ul >
              <li><a  target="_blank" class="collection-item teal-text">{{ titleOne }}</a></li>
              <li><a  target="_blank" class="collection-item teal-text">{{ titleTwo }}</a></li>
            </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  props: ['titleOne', 'titleTwo']
}
</script>

<style>
.padding{
  padding: 25px;
}
.tag{
  color: rgb(0, 0, 0);
}
.Q{
  max-width: 1000px;
  margin: 0 auto;
} 
</style>